/**
 * Vehicle engine layout values
 */
export enum VehicleEngineLayoutEnum {
	FRONT_LONGITUDINAL = 'front-longitudinal',
	FRONT_TRANSVERSE = 'front-transverse',
	MIDDLE_LONGITUDINAL = 'middle-longitudinal',
	MIDDLE_TRANSVERSE = 'middle-transverse',
	REAR_LONGITUDINAL = 'rear-longitudinal',
	REAR_TRANSVERSE = 'rear-transverse',
}
